import { render, staticRenderFns } from "./PageEditorContentNavContentItem.vue?vue&type=template&id=64bddfa5&scoped=true"
import script from "./PageEditorContentNavContentItem.vue?vue&type=script&lang=js"
export * from "./PageEditorContentNavContentItem.vue?vue&type=script&lang=js"
import style0 from "./PageEditorContentNavContentItem.vue?vue&type=style&index=0&id=64bddfa5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bddfa5",
  null
  
)

export default component.exports